<template>
  <span>
    <div class="tutorial--modal">
      <h3 style="font-family: Baller">Start</h3>
      <div class="row">
        <img src="../assets/step1.svg" alt="Tutorial First Instruction" />
        <section>
          <div class="step">1</div>
          <div class="instruction">Pick a country from anywhere on the map</div>
        </section>
      </div>
      <div class="row right">
        <section>
          <div class="step">2</div>
          <div class="instruction">Read and filter content from that country</div>
        </section>
        <img src="../assets/step2.svg" alt="Tutorial Second Instruction" />
      </div>
      <button v-on:click="closeTutorial">Let's Go</button>
    </div>
  </span>
</template>
<script>
export default {
  name: "welcome",
  computed: {},
  components: {},
  methods: {
    closeTutorial() {
      this.$emit("closeTutorial");
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
@import "../style/components/tutorial";
@import "../style/components/button";
</style>
